












import { Component, Mixins } from "vue-property-decorator";

@Component({
  components: {
  }
})
export default class PerformanceViewer extends Mixins() {
  get contentText(): string {
    console.log(window.performance);
    const content = {
      memory: this.createMemoryContent(),
      timeOrigin: (window.performance as any).timeOrigin,
      timing: this.createTimingContent(),
    };
    return JSON.stringify(content, null , "  ");
  }

  createMemoryContent(): any {
    const performance = window.performance as any;
    const memory = performance.memory;
    if (!memory) { return null; }
    return {
      jsHeapSizeLimit: memory.jsHeapSizeLimit.toLocaleString(),
      totalJSHeapSize: memory.totalJSHeapSize.toLocaleString(),
      usedJSHeapSize: memory.usedJSHeapSize.toLocaleString(),
    };
  }

  createTimingContent(): any {
    const timing = window.performance.timing;
    if (!timing) { return null; }
    return {
      unloadEventStart: this.createDiffText(timing.navigationStart, timing.unloadEventStart),
      unloadEventEnd: this.createDiffText(timing.navigationStart, timing.unloadEventEnd),
      redirectStart: this.createDiffText(timing.navigationStart, timing.redirectStart),
      redirectEnd: this.createDiffText(timing.navigationStart, timing.redirectEnd),
      fetchStart: this.createDiffText(timing.navigationStart, timing.fetchStart),
      domainLookupStart: this.createDiffText(timing.navigationStart, timing.domainLookupStart),
      domainLookupEnd: this.createDiffText(timing.navigationStart, timing.domainLookupEnd),
      connectStart: this.createDiffText(timing.navigationStart, timing.connectStart),
      connectEnd: this.createDiffText(timing.navigationStart, timing.connectEnd),
      secureConnectionStart: this.createDiffText(timing.navigationStart, timing.secureConnectionStart),
      requestStart: this.createDiffText(timing.navigationStart, timing.requestStart),
      responseStart: this.createDiffText(timing.navigationStart, timing.responseStart),
      responseEnd: this.createDiffText(timing.navigationStart, timing.responseEnd),
      domLoading: this.createDiffText(timing.navigationStart, timing.domLoading),
      domInteractive: this.createDiffText(timing.navigationStart, timing.domInteractive),
      domContentLoadedEventStart: this.createDiffText(timing.navigationStart, timing.domContentLoadedEventStart),
      domContentLoadedEventEnd: this.createDiffText(timing.navigationStart, timing.domContentLoadedEventEnd),
      domComplete: this.createDiffText(timing.navigationStart, timing.domComplete),
      loadEventStart: this.createDiffText(timing.navigationStart, timing.loadEventStart),
      loadEventEnd: this.createDiffText(timing.navigationStart, timing.loadEventEnd),
    };
  }

  createDiffText(from: number, to: number): string {
    if (!from || !to) { return "-"; }
    return (to - from).toLocaleString();
  }
}
